module.exports = __webpack_public_path__ + "img/ensemble.cf4fccd8.jpg";